import React from 'react';

export default function Resources() {
  return <div>Admin Resources Form</div>;
}
